import React from 'react';
import { Link } from 'react-router-dom';

import VulnersIcon from './assets/vulners.svg';
import useStyles from './styles';

interface Props {
    className?: string;
}

const Logo: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();

    return (
        <Link to="/" className={cx(classes.root, className)}>
            <VulnersIcon />
            <span className={classes.text}>{'Vulners'}</span>
        </Link>
    );
};

export default Logo;
